import { ApolloError } from 'apollo-boost';

export const isApolloErrorGuard = (error: ApolloError | string[]): error is ApolloError => {
	return !!(error as ApolloError)?.graphQLErrors;
};
